import React from 'react'
import { useVideoPlayer } from '../../../hooks/useVideoPlayer'
import interviewsImage from 'assets/interviews.jpeg'

export const LifeThroughLegalLensComingSoonSection = () => {
  return (
    <section className='mb-12 mt-16'>
      <h2 className='text-2xl font-semibold py-12'>
        Life through the legal lens
      </h2>
      <div className='flex flex-col sm:flex-row gap-12'>
        <div className='w-full sm:w-1/2'>
          <img src={interviewsImage} />
        </div>
        <div className='w-full sm:w-1/2 flex flex-col justify-center mt-8 sm:mt-0'>
          <div>
            <h3 className='text-xl font-semibold mb-4'>
              Your legal inspiration
            </h3>
            <p className='text-[#6E7785] mb-4'>
              Unlock a wealth of legal knowledge by diving into our exclusive
              collection of interviews with experts and specialists. Whether
              you're seeking insights on the latest legal trends or important
              transactions, Life through the legal lens offers you immediate
              inspiration. Start watching today for these exclusive insights.
            </p>
            <span className='text-lg text-[#37A2BA]'>Coming soon</span>
          </div>
        </div>
      </div>
    </section>
  )
}
